module.exports = __webpack_public_path__ + "static/media/logo-default.1a1271e1.svg";